export const toggleClass = (target, className, isActive) => {
    target?.classList?.toggle(className, isActive);
};

export const toggleDisplay = (target, isForceDisplay) => {
    const isNone = !target?.style?.display || target?.style?.display === 'none';
    target.style.display = isNone || isForceDisplay ? 'block' : 'none';
};

export const empty = (target) => {
    if(!target) {
        return;
    }

    while(target?.firstChild) {
        target.removeChild(target?.firstChild);
    }
};

export const getIndex = (el) => {
    if(!el) return -1;

    let i = 0;
    while(el = el.previousElementSibling) {
        i++;
    }
    return i;
}

export const ready = callback => {
    if(typeof callback === 'function') {
        if(document.readyState !== 'loading') {
            callback();
        } else {
            document.addEventListener('DOMContentLoaded', callback);
        }
    }
};